import { Component, OnInit } from '@angular/core';
import { MgService } from 'src/app/services/mg.service';

@Component({
  selector: 'app-home-operator',
  templateUrl: './home-operator.component.html',
  styleUrls: ['./home-operator.component.scss']
})
export class HomeOperatorComponent implements OnInit {

  public isLoading: boolean = false;
  public openCalls: number;
  public ongoingCalls: number;
  public pendingCalls: number;
  public thisMonthCalls: number;
  public closedTodayCalls: number;
  public monthlyCalls: any[];

  constructor(
    private api: MgService,
  ) { }

  ngOnInit(): void {
    this.getHomeInfosAtAPI();
  }

  public getHomeInfosAtAPI() {
    this.isLoading = true;
    this.api.listHomeInfos()
      .subscribe(
        res => {
          this.openCalls = res.openCalls;
          this.ongoingCalls = res.ongoingCalls;
          this.pendingCalls = res.pendingCalls;
          this.thisMonthCalls = res.thisMonthCalls;
          this.closedTodayCalls = res.closedTodayCalls;
          this.monthlyCalls = res.monthlyCalls;
          this.isLoading = false;
        },
        err => {
          this.isLoading = false;
        }
      )
  }

}
